import { render, staticRenderFns } from "./TopOffersTable.vue?vue&type=template&id=14028085&"
import script from "./TopOffersTable.vue?vue&type=script&lang=ts&"
export * from "./TopOffersTable.vue?vue&type=script&lang=ts&"
import style0 from "./TopOffersTable.vue?vue&type=style&index=0&id=14028085&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports